import {useState, useEffect} from 'react';
import {useLocale} from '../../Localization/LocaleContext';

// Temporarily disable the first-time-customer promotion banner.
const TOP_NOTIFICATION_ENABLED = false;

const TopNotification = () => {
  const {translate: t} = useLocale();
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    const hidden = localStorage.getItem('hideTopNotification') === 'true';
    setIsHidden(hidden);
  }, []);

  const onClose = () => {
    setIsHidden(true);
    localStorage.setItem('hideTopNotification', 'true');
  };

  if (!TOP_NOTIFICATION_ENABLED) return null;

  if (isHidden) return null;

  return (
      <div
        className="sticky top-0 z-100 rounded-sm bg-white py-2 text-sm shadow dark:bg-dark_primary dark:text-dark_font_primary"
        id="top-notification">
        <div className="max-w-full mx-auto px-4 w-full flex  flex-col md:flex-row justify-center  items-center gap-2">
          <div className=" flex-grow flex  flex-col lg:flex-row items-center  justify-center  gap-5 lg:gap-10 font-medium h-full w-full lg:w-auto my-auto">
            <div className="flex flex-col justify-center items-center gap-0.5  ">
              <p className="animate-charcter text-center text-lg text-gray-900 dark:text-dark_font_primary">
                {t('navigation.promo_banner', {percent: 25, code: 'DREAM26'}, 'Get {percent}% OFF! Only for first-time customers. Use code: {code}.')}
              </p>
              {/* <p className=" text-xs text-black font-light  ">* Only for new paid subscription</p> */}
            </div>
            {/* <div className="flex justify-center flex-wrap lg:justify-start items-center gap-2">
            <p className=" ">Ending in : </p>
            {<Countdown />}
          </div> */}
          </div>

          <div className=" md:flex-none flex flex-row items-center gap-3">
            {/* <Link href={'/workspace/plans'} legacyBehavior>
            <a className="font-medium inline-flex items-center justify-center border border-primary bg-primary hover:bg-transparent text-white hover:text-primary rounded leading-snug transition duration-150 ease-in-out px-8 py-2">
              See Plan
            </a>
          </Link> */}
            <button
              className="absolute right-2 top-0 top bottom-0 my-auto opacity-70 hover:opacity-80 md:relative md:right-0 text-gray-700 dark:text-dark_font_primary"
              onClick={onClose}>
              <div className="sr-only">{t('common.close', 'Close')}</div>
              <svg className="w-4 h-4 fill-current">
                <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
  );
};

export default TopNotification;
